import React from "react";
import { Flex, Text } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import TeamButton from "../../atoms/TeamButton";
import { observer } from "mobx-react-lite";
import Constants from "../../../constants/text-constants";

const MyTeamsList = observer((props) => {
  const { teams, setTeamRegistration } = props;

  return (
    <Flex gap="gap.small" wrap data-testid="myTeamsList" className="my-teams-list">
      {teams.length === 0 ? <Text data-testid="myTeamsListMsg" className="my-teams-msg">{Constants.NO_TEAMS_MSG}</Text> : null}
      {teams.map((team) => {
        return (
          <TeamButton
            key={team.team.id}
            id={team.team.id}
            text={team.team.name}
            loggedIn={team.loggedIn}
            onClickHandler={setTeamRegistration}
          />
        );
      })}
    </Flex>
  );
});

MyTeamsList.propTypes = {
  teams: PropTypes.array,
};

MyTeamsList.defaultProps = {
  teams: [],
};

export default MyTeamsList;
